import { render, staticRenderFns } from "./WinnerIcon.vue?vue&type=template&id=39a77696&scoped=true"
import script from "./WinnerIcon.vue?vue&type=script&lang=js"
export * from "./WinnerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a77696",
  null
  
)

export default component.exports